import React from 'react';
import ReactDOM from 'react-dom/client';
import SocialStarLanding from './SocialStarLanding';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<SocialStarLanding />);